import React, { useRef, useState } from "react";
import "./footer.css";
import { Link, useNavigate } from "react-router-dom";

import CustDialogBox from "../../components/custom dialogbox/CustDialogBox";
import ContactUs from "../../pages/home/dialog box/ContactUs";
import AlertCustDialogBox from "../../components/alertbox/AlertCustDialogBox";
import Alertbox from "../../components/alertbox/Alertbox";
const dwec_logo = require("../../assets/dwec_logo.png");
const design_footer = require("../../assets/footer_bg_1.svg");
// const logo_gif = require("../../assets/Final-transp-unscreen.gif")
export default function Footer(props) {
  const navigate = useNavigate();

  const [toggleModal, setToggleModal] = useState(false);
  const [alertToggleModal, setAlertToggleModal] = useState(false);

  const allCountryDestinationContent = [
    {
      countryName: "CANADA",
    },
    {
      countryName: "GERMANY",
    },
    {
      countryName: "USA",
    },
    {
      countryName: "AUSTRALIA",
    },
    {
      countryName: "UK",
    },
    {
      countryName: "U.A.E",
    },
  ];

  function handleContactClick(toggleValue) {
    console.log(toggleValue, "line 17");
    setToggleModal(toggleValue);
  }
  function hanldeContactPopUp(toggleValue) {
    setAlertToggleModal(toggleValue);
    setTimeout(() => {
      setAlertToggleModal(false);
    }, 2000);
  }
  return (
    <div className="main_footer_container">
      <div className="footer_under_container">
        <div className="flex_footer_container">
          <div className="first_container_footer">
            <div className="logo_content_container">
              <div className="logo_container">
                {/* <img
                  src={dwec_logo}
                  alt="dwec_logo"
                  className="dwec_logo_self"
                /> */}
              </div>
              <p className="about_dwec_paragraph_text">
                Dynamic World Education Community (DWEC) is a premier overseas
                education facilitator situated in Vadodara, Gujarat.
                <br />
                We are an authorized representative of over 3300 universities
                and institutions across 20+ countries.
              </p>
            </div>
          </div>
    
          
                <div className="sec_container_footer">
                  <div className="header_container">
                  <p className="footer_title">Country</p>
                    <div className="footer_country_name_container">
                     
                      {
                        allCountryDestinationContent.map((perCountryItem) => {
                          return (
                        <li
                            href="#explorepage"
                            onClick={() => {
                              navigate("/Countries", {
                                state: perCountryItem.countryName,
                              });
                            }}
                            className="content_text_footer"
                          >
                            <Link to="/Countries" className="content_text_footer">
                            {perCountryItem.countryName}
                  </Link>
                          
                        </li>
                        );
                      })}
                      
                    </div>
                  </div>
                </div>
              

          {/* <div className="sec_container_footer">
            <div className="header_container">
              <p className="footer_title">Country</p>
              <div className="footer_country_name_container">
                <li>
                  <Link to="/Countries"  className="content_text_footer">
                    Canada
                  </Link>
                </li>
                <li>
                  <Link to="/Countries" className="content_text_footer">
                    UK
                  </Link>
                </li>
                <li>
                  <Link to="/Countries" className="content_text_footer">
                    Germany
                  </Link>
                </li>
                <li>
                  <Link to="/Countries#explorepage" className="content_text_footer">
                    Australia
                  </Link>
                </li>
                <li>
                  <Link to="/Countries#explorepage" className="content_text_footer">
                    USA
                  </Link>
                </li>
                <li>
                  <Link to="/Countries#explorepage" className="content_text_footer">
                    UAE
                  </Link>
                </li>
              </div>
            </div>
          </div> */}

          <div className="third_container_footer">
            <div className="header_container">
              <p className="footer_title">Navigations</p>
              <div className="footer_country_name_container">
                <li>
                  <Link to="/" className="content_text_footer">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/NewsUpdatesPage" className="content_text_footer">
                    News & Updates
                  </Link>
                </li>
                <li>
                  <Link to="/Blog" className="content_text_footer">
                    Blogs
                  </Link>
                </li>

                <li>
                  <Link to="/BookCounselling" className="content_text_footer">
                    Book Online Counselling
                  </Link>
                </li>
                <li>
                  <Link to="/AboutUsMain" className="content_text_footer">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/ContactUsPage" className="content_text_footer">
                    Reach to Us
                  </Link>
                </li>
              </div>
            </div>
          </div>
          <div className="four_container_footer">
            <div className="header_container">
              <p className="footer_title">OUR GLOBAL PRESENCE</p>
              <div className="footer_country_name_container">
                <div>
                  <div className="content_text_footer">
                    <div className="img_link_text_container">
                      <Link
                        to="/ContactUsPage"
                        className="content_text_footer1"
                      >
                        India
                      </Link>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="content_text_footer">
                    <div className="img_link_text_container">
                      <Link
                        to="/ContactUsPage"
                        className="content_text_footer1"
                      >
                        United Kingdom
                      </Link>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="content_text_footer">
                    <div className="img_link_text_container">
                      <Link
                        className="content_text_footer1"
                        to="/ContactUsPage"
                      >
                        Nepal
                      </Link>
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
            </div>
          </div>
          <div className="fifth_container_footer">
            <div className="header_container">
              <p className="footer_title">For any business enquiries </p>
              <button
                className="contact_us_btn"
                onClick={() => handleContactClick(true)}
              >
                Contact Us
              </button>
            </div>
          </div>
        </div>
        <div className="privacy_terms_container">
          <div className="text_content_container">
            <Link to="/PrivacyPage" className="privacy_terms_text">
              Privacy & Policy
            </Link>
            <Link to="/TermsAndConditions" className="privacy_terms_text">
              Terms & Conditions
            </Link>
            <Link to="/RefundPage" className="privacy_terms_text">
              Refund & Cancellation
            </Link>
          </div>
        </div>
      </div>

      <CustDialogBox
        dialogHeaderName="For any business enquiries"
        open={toggleModal}
        onClose={() => {
          setToggleModal(false);
        }}
      >
        <ContactUs
          hanldeContactPopUp={hanldeContactPopUp}
          handleContactClick={handleContactClick}
        />
      </CustDialogBox>
      <AlertCustDialogBox
        dialogHeaderName=""
        open={alertToggleModal}
        onClose={() => {
          setAlertToggleModal(false);
        }}
      >
        <Alertbox />
      </AlertCustDialogBox>

      <img
        className="design_footer"
        alt="design_footer"
        src={design_footer.default}
      />
    </div>
  );
}
